import * as $ from "jquery";
import * as Oidc from "oidc-client";
import {UserManagerSettings} from "oidc-client";

export default class OidcManager {

    public user: Oidc.User | undefined;

    private mgr: Oidc.UserManager;

    constructor(private options: UserManagerSettings) {

        this.mgr = new Oidc.UserManager(options);

        this.mgr.events.addAccessTokenExpired(ev => {
            console.log("access token expired fired");
            this.mgr.signoutRedirect();
        });

        this.mgr.events.addSilentRenewError(function(error){
            console.log("error silently renewing access token", error);
        });

        this.mgr.events.addAccessTokenExpiring(ev => {
            console.log("access token expiring fired");
            
            this.mgr.signinSilent({scope: options.scope, response_type: options.response_type})
                .then((user: Oidc.User) => {
                    console.log("access token expiring: signinSilent successful", user);
                    this.user = user;
                })
                .catch((error: Error) => {
                    console.log("access token expiring: signinSilent failed", error);
                    //Work around to handle to Iframe window timeout errors on browsers
                    this.mgr.getUser().then((user: Oidc.User | null) =>
                    {
                        console.log("access token expiring: signinSilent failed: getUser successful", user);
                        if (user)
                            this.user = user;
                    });
                });
        });
    }

    public logout()
    {
        console.log("logout fired");
        let endSessionEndpoint = this.mgr.settings.metadata!.end_session_endpoint;
        window.location.href = endSessionEndpoint + "?id_token_hint=" + this.user!.id_token +
            "&post_logout_redirect_uri=" + this.options.post_logout_redirect_uri;
    }
    
    public authorize() {
        console.log("authorize fired");
        let dfd = $.Deferred();

        if (this.user) {
            return dfd.resolve().promise();
        }

        this.mgr.getUser().then((user) => {
            console.log("authorize:getUser complete");
            console.log(user);
            if (!user) {
                this.mgr.signinRedirect().then((x) => {
                    dfd.reject();
                });
                return;
            }

            if (user.expired) {
                console.log("authorize:getUser user expired");
                this.mgr.signinSilent({scope: this.options.scope, response_type: this.options.response_type})
                    .then((user: Oidc.User) => {
                        console.log("authorize:getUser:signinSilent complete");
                        this.user = user;
                        dfd.resolve();

                    })
                    .catch((error: Error) => {
                        console.log("authorize:getUser:signinSilent failed, calling getUser()");
                        //Work around to handle to Iframe window timeout errors on browsers
                        this.mgr.getUser().then((user: Oidc.User | null) =>
                        {
                            if (user == null) {
                                console.log("getUser is null")
                                dfd.resolve();
                                return;
                            }

                            console.log("getUser successful")
                            console.log(user);
                            this.user = user;
                            dfd.resolve();
                        });
                    });
            }
            else {
                this.user = user;
                dfd.resolve();

            }
        });

        return dfd.promise();
    }

    check() {
        let dfd = $.Deferred();
        
        this.mgr.getUser().then((user) => {
            if (!user) {
                this.mgr.signinRedirect().then(() => {
                    dfd.reject();
                });
            }
            else {
                this.user = user;
                dfd.resolve();
            }
        }, error => {
            dfd.reject(error);
        });

        return dfd.promise();
    }
}


// WEBPACK FOOTER //
// ./ClientApp/services/api/oidcManager.ts